import * as _ from 'underscore';

import React from 'react';
import Tooltip from 'material-ui/Tooltip';

import Button from 'material-ui/Button';
import FilterIcon from '@material-ui/icons/FilterList';

import MDSearch from './MegaDropSearch';
import MDList from './MegaDropList';

import badgeStyle from '../../../../lib/customStyles/badgeStyle';

import Console from '../../../../lib/debug';

export const ARROW_DIRECTIONS = { DOWN: 1, UP: -1 };
const SCROLL_UP_PIXELS = 30;

export default class MegaDrop extends React.Component {
    state = {
        selected: false,
        emptyError: false,
        isFocused: false,
        search: '',
        itemPosition: 0
    };

    autoFocused = false;
    itemsRef = {};

    bodyClick = e => {
        let $srcEl = e.target;
        if (this.$parent && !this.$parent.contains($srcEl)) {
            this.close();
        }
    };

    close = () => {
        document.body.removeEventListener('click', this.bodyClick);
        let emptyError = false;
        if (!this.state.selected) {
            emptyError = true;
        }
        this.setState(() => ({
            isFocused: false,
            search: '',
            view: 'items',
            dropOuterWidth: 0,
            itemPosition: 0,
            emptyError
        }));
        document.body.classList.remove('fixWindow');
        this.props.onClose && this.props.onClose();
    };

    componentDidMount() {
        // eslint-disable-next-line
        this.setState(() => ({
            selected: this.props.value ? true : false
        }));
        if (this.props.auto) {
            this.focus({ preventScroll: false });
        }
    }

    componentDidUpdate() {
        if (this.props.auto && !this.autoFocused) {
            this.focus({ preventScroll: false });
            this.autoFocused = true;
        }
    }

    focus = () => {
        document.body.addEventListener('click', this.bodyClick);
        if (!this.props.published) {
            if (!this.state.isFocused) {
                this.searchInput &&
                    this.searchInput.focus({ preventScroll: false });
                this.setState(() => ({
                    isFocused: true,
                    search: ''
                }));
                // Move window in case MegaDrop is not visible
                this.moveMegaDrop();
                this.props.onOpen && this.props.onOpen();
            } else {
                this.searchInput.focus({ preventScroll: false });
            }
        }
    };

    getClearFiltersButton = () => {
        return (
            <Button
                className="MegaDrop-create-new"
                key="clearfilters"
                onClick={this.handleClearFilter}
            >
                <i className="mdi mdi-refresh" />
                Clear Filters
            </Button>
        );
    };

    getCreateNewButton = () => {
        let createNew = [];
        if (this.props.createItem) {
            let t = this.props.type;
            let type = t.charAt(0).toUpperCase() + t.slice(1);
            if (t === 'circuit') {
                type = t.charAt(0).toUpperCase() + t.slice(1);
            }
            let buttonLabel = t === 'exercise' ? `New ${type}` : `New ${type}`;
            let materialIcon =
                t === 'exercise' ? (
                    <i className="mdi mdi-table" />
                ) : (
                    <i className="mdi mdi-alphabetical" />
                );

            createNew.push(
                <Button
                    className="MegaDrop-create-new"
                    key="newex"
                    onClick={() => this.handleNewItem(type.toLowerCase())}
                >
                    {materialIcon}
                    {buttonLabel}
                </Button>
            );
            if (this.props.extra) {
                let tooltipMessage = this.props.blockIsSaving
                    ? 'Please wait'
                    : 'Create new Circuit';
                createNew.push(
                    <Button
                        className={`MegaDrop-create-new${
                            this.props.blockIsSaving ? ' disabled' : ''
                        }`}
                        key="necirc"
                        onClick={() => this.handleNewItem('circuit')}
                    >
                        <i className="mdi mdi-alphabetical" />
                        New Circuit
                    </Button>
                );
            }
        }
        return createNew;
    };

    getOptionLabel = () => {
        let optionLabel = null;
        let selectedValue = this.props.value;
        if (this.props.type === 'circuit') {
            selectedValue = this.props.value
                ? _.find(this.props.optionsRef, {
                      id:
                          this.props.value.workout_combo_id ||
                          this.props.value.exercise_id
                  })
                : null;
        }

        if (!selectedValue && !this.state.search) {
            let title = null;
            let titleClasses = null;
            if (this.state.isFocused) {
                title = '';
                titleClasses = 'MegaDrop-value-label placeholder-on';
            } else {
                title = this.props.placeholder;
                titleClasses = 'MegaDrop-value-label placeholder-on';
            }
            optionLabel = (
                <div className="MegaDrop-value">
                    <span className={titleClasses}>{title}</span>
                </div>
            );
        } else if (selectedValue && !this.state.search) {
            optionLabel = (
                <div
                    className={`MegaDrop-value${
                        this.props.value ? ' MegaDrop-item-selected' : ''
                    }`}
                >
                    <span className="MegaDrop-value-label">
                        {selectedValue.title}
                    </span>
                </div>
            );
        } else if (selectedValue && this.state.search) {
            optionLabel = (
                <div
                    className={`MegaDrop-value${
                        this.props.value ? ' MegaDrop-item-selected' : ''
                    }`}
                >
                    <span className="MegaDrop-value-label">
                        {selectedValue.title}
                    </span>
                </div>
            );
        }

        return !this.state.isFocused ? optionLabel : null;
    };

    getOptions = () => {
        let filteredResults = [];
        let suggested = this.getSuggestedItems();
        filteredResults = _.filter(this.props.options, o => {
            o.selected = false;
            o.title = o.label;
            o.title = o.title.trim();
            return (
                o.title
                    .toLowerCase()
                    .replace(/[\s-]+/g, '')
                    .indexOf(
                        this.state.search.toLowerCase().replace(/[\s-]+/g, '')
                    ) >= 0
            );
        });
        if (this.state.search === '') {
            filteredResults = filteredResults.filter(
                item => !_.find(suggested, { id: item.id })
            );
            filteredResults = _.sortBy(filteredResults, item =>
                item.title.toLowerCase()
            );
            filteredResults = [...suggested, ...filteredResults];
        }
        if (filteredResults.length) {
            let pos = this.props.selectedTags ? 0 : this.state.itemPosition;
            filteredResults[pos].selected = true;
        }
        return filteredResults;
    };

    getTags = () => {
        let tags = [...this.props.tags];
        let allOptions = [
            ...(this.props.optionsRef.options
                ? this.props.optionsRef.options
                : this.props.optionsRef)
        ];
        tags = tags.map(tag => {
            let t = { ...tag };
            t.exercises = [];
            let matchedExercises = allOptions.filter
                ? allOptions.filter(option =>
                      _.find(
                          option.tags,
                          optionTag => parseInt(optionTag.id) === parseInt(t.id)
                      )
                  )
                : [];
            let title = t.title.trim();
            t.isTag = true;
            t.exercises = matchedExercises;
            t.title = title.charAt(0).toUpperCase() + title.slice(1);
            return t;
        });
        return _.sortBy(tags, item => item.title.toLowerCase());
    };

    getSuggestedItems = () => {
        let suggested = [];
        let currentTags = this.props.selectedTags;
        if (!currentTags.length) {
            let allOptions = this.props.optionsRef.options
                ? this.props.optionsRef.options
                : this.props.optionsRef;
            allOptions = [...allOptions];
            suggested = allOptions.sort((a, b) => {
                a.selected = false;
                return -(parseFloat(a.use_count) - parseFloat(b.use_count));
            });
            suggested.splice(10, suggested.length - 10);
            suggested = _.sortBy(suggested, item => item.title);
            suggested.push({
                id: 'separator',
                category: 'separator',
                fake: true
            });
        }
        return suggested;
    };

    handleClearFilter = () => {
        this.props.handleTags([]);
    };

    handleFilterSelect = tag => {
        let foundKey = null;
        let currentTags = this.props.selectedTags;
        currentTags.map((_tag, i) => {
            if (parseInt(_tag.id) === parseInt(tag.id)) {
                foundKey = i;
            }
        });
        if (foundKey !== null) {
            currentTags.splice(foundKey, 1);
        } else {
            currentTags.push(tag);
        }
        this.props.handleTags(currentTags);
    };

    handleFilterToggle = () => {
        if (this.state.isFocused) {
            this.close();
        } else {
            this.focus();
        }
    };

    handleKey = e => {
        let isMDOpen = this.state.isFocused;
        if (isMDOpen && e.key === 'Escape') {
            this.close();
        }
    };

    getRealItems = allItems => {
        return allItems.filter(i => !i.fake);
    };

    updatedPosition = (direction, items) => {
        let position = this.state.itemPosition + direction;
        if (items[position] && items[position].fake) {
            position = position + direction;
        }

        const lastIndex = items.length - 1;
        if (position >= lastIndex) return lastIndex;

        const firstIndex = 0;
        if (position <= firstIndex) return firstIndex;

        return position;
    };

    handleArrow = direction => {
        const allItems = this.getOptions();
        const realItems = this.getRealItems(allItems);
        const itemPosition = this.updatedPosition(direction, allItems);
        this.setState({ itemPosition });
        this.moveOuter(direction, realItems, itemPosition);
    };

    handleEnter = () => {
        const allItems = this.getOptions();
        this.handleSelect(allItems[this.state.itemPosition]);
    };

    handleKeyOnSearch = event => {
        if (!this.state.isFocused) return;
        switch (event.key) {
            case 'ArrowDown':
                return this.handleArrow(ARROW_DIRECTIONS.DOWN);
            case 'ArrowUp':
                return this.handleArrow(ARROW_DIRECTIONS.UP);
            case 'Enter':
                return this.handleEnter();
        }
    };

    handleNewItem = type => {
        let _type = type || 'exercise';
        if (!this.props.blockIsSaving) {
            if (this.props.value && _type === 'circuit') {
                let isEmptyCircuit = !this.props.value.workout_combo_id;
                if (isEmptyCircuit) {
                    this.focus();
                } else if (!isEmptyCircuit) {
                    this.props.onChangeToEmptyCircuit &&
                        this.props.onChangeToEmptyCircuit();
                }
            } else {
                this.props.createItem(this.state.search, type);
            }
            this.close();
        }
    };

    handleItemChange = value => {
        this.setState(() => ({
            search: value,
            view: 'items',
            itemPosition: 0
        }));
        this.$container.scrollTop = 0;
    };

    handleItemBlur = value => {
        let isEmptyCircuit =
            this.props.type === 'circuit' &&
            this.props.value.workout_combo_id === null;
        if (isEmptyCircuit && this.props.onTitleChange) {
            this.props.onTitleChange(value);
        }
    };

    handleSelect = it => {
        this.state.selected = true;
        this.props.itemSelect(it);
        this.close();
    };

    isOutside = el => {
        let containerValues = this.$container.getBoundingClientRect();
        let elValues = el.getBoundingClientRect();
        let containerTop = containerValues.top;
        let containerHeight = containerValues.height;
        let itemTop = elValues.top;
        let itemHeight = elValues.height;
        let posInCont = itemTop - containerTop;
        return {
            isOutside:
                posInCont < 0 || posInCont + itemHeight > containerHeight,
            excess: posInCont + itemHeight - containerHeight
        };
    };

    moveMegaDrop = () => {
        const MD_OUTER_HEIGHT = 311;
        const AIR = 20;
        let $body = document.querySelector('body');
        let $html = document.querySelector('html');
        let parentRect = this.$parent.getBoundingClientRect();
        let bodyHeight = $body.offsetHeight;
        let mdTop = parentRect.top;
        let mdHeight = parentRect.height + MD_OUTER_HEIGHT;
        if (bodyHeight - (mdTop + mdHeight) < 0) {
            $body.scrollTop += Math.abs(bodyHeight - (mdTop + mdHeight)) + AIR;
            $html.scrollTop += Math.abs(bodyHeight - (mdTop + mdHeight)) + AIR;
        }
        this.$container.scrollTop = 0;
    };

    moveOuter = (direction, allItems, position) => {
        let el = this.itemsRef[allItems[position].id];
        if (!el) return;

        let status = this.isOutside(el);
        if (!status.isOutside) return;

        if (direction === ARROW_DIRECTIONS.DOWN) {
            this.$container.scrollTop +=
                el.getBoundingClientRect().height + status.excess;
        }
        if (direction === ARROW_DIRECTIONS.UP) {
            const scrollAmount =
                el.getBoundingClientRect().height + SCROLL_UP_PIXELS;
            this.$container.scrollTop -= scrollAmount;
        }
    };

    render() {
        Console.render('designer.MegaDrop');
        let items = this.state.isFocused ? this.getOptions() : [];
        let allTags = this.state.isFocused ? this.getTags() : [];
        let selectedValue = this.props.value;
        let isEmptyCircuit =
            this.props.type === 'circuit' &&
            selectedValue.workout_combo_id === null;
        let optionLabel = !isEmptyCircuit ? this.getOptionLabel() : null;
        let createNew = this.state.isFocused && this.getCreateNewButton();
        let clearFilters = this.state.isFocused && this.getClearFiltersButton();
        let selectedTags = this.props.selectedTags;
        let _badgeStyle = {
            ...badgeStyle,
            fontSize: 11,
            lineHeight: 2.9,
            color: this.state.isFocused ? '#fff' : '#1f242a'
        };
        let centerButtonStyles = {
            minWidth: 40,
            minHeight: 40,
            marginLeft: 4,
            border: '1px solid #e9e9e9',
            color: this.state.isFocused ? '#fff' : '#1f242a',
            borderRadius: 0,
            marginTop: 0
        };

        let filterBadge = null;
        let filtersListTop = null;
        if (selectedTags.length) {
            filterBadge = (
                <span style={_badgeStyle} className="btn-badge">
                    {selectedTags.length}
                </span>
            );
            filtersListTop = (
                <div className="MegaDrop-list-top">
                    <span>{`${selectedTags.length} filter${
                        selectedTags.length > 1 ? 's' : ''
                    } applied`}</span>
                </div>
            );
        }

        let exercisesListTop = items.length ? (
            <div className="MegaDrop-list-top">
                <span>{`${items.length} exercise${
                    items.length > 1 ? 's' : ''
                } shown`}</span>
            </div>
        ) : null;

        const filterTooltip =
            'Use filters to hone in on specific movements,' +
            '\nexercises, workouts, and circuits';
        let mdFilter = (
            <div className="MegaDrop-filter">
                <Tooltip
                    title={
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {filterTooltip}
                        </div>
                    }
                >
                    <Button
                        className={`MegaDrop-button ${
                            this.state.isFocused ? 'active' : ''
                        }`}
                        data-for="MegaDrop"
                        onClick={this.handleFilterToggle}
                    >
                        <FilterIcon />
                        {filterBadge}
                    </Button>
                </Tooltip>
            </div>
        );

        let mdArrow = null;
        let dropdown = null;

        if (!isEmptyCircuit) {
            mdArrow = (
                <div className="Select-arrow-zone" onClick={this.close}>
                    <span className="mdi mdi-chevron-down" />
                </div>
            );
        } else {
            dropdown = (
                <div className="MegaDrop-dropdown">
                    <Button
                        className={`MegaDrop-button ${
                            this.state.isFocused ? 'active' : ''
                        }`}
                        color="primary"
                        style={centerButtonStyles}
                        onClick={this.handleFilterToggle}
                    >
                        <span className="mdi mdi-chevron-down" />
                    </Button>
                </div>
            );
        }

        return (
            <div
                className={`MegaDrop-parent ${
                    this.state.isFocused ? 'active' : ''
                }`}
                ref={el => {
                    this.$parent = el;
                }}
            >
                <div
                    className={`MegaDrop${
                        isEmptyCircuit ? ' is-new-circuit' : ''
                    }${this.state.isFocused ? ' MegaDrop-is-open' : ''}`}
                    onKeyUp={this.handleKey}
                >
                    <div className="MegaDrop-control-wrapper">
                        <div
                            className={`MegaDrop-control${
                                this.state.emptyError ? ' empty' : ''
                            }`}
                            onClick={
                                !isEmptyCircuit ? () => this.focus() : null
                            }
                        >
                            <div className="MegaDrop-multi-value-wrapper">
                                <MDSearch
                                    show={this.state.isFocused}
                                    inputRef={el => {
                                        this.searchInput = el;
                                    }}
                                    type={this.props.type}
                                    value={this.props.value}
                                    isMDOpen={this.state.isFocused}
                                    selectedValue={selectedValue}
                                    search={this.state.search}
                                    isEmptyCircuit={isEmptyCircuit}
                                    isNewExercise={this.props.isNewExercise}
                                    exercisesRef={this.props.optionsRef}
                                    placeholder={
                                        this.state.search
                                            ? ''
                                            : this.props.placeholder
                                    }
                                    onKeyUp={this.handleKeyOnSearch}
                                    onChange={this.handleItemChange}
                                    onBlur={this.handleItemBlur}
                                />
                                {optionLabel}
                            </div>
                            {mdArrow}
                        </div>
                        {dropdown}
                        {mdFilter}
                    </div>
                    <div
                        className={`MegaDrop-menu-outer${
                            this.state.isFocused ? ' active' : ''
                        }`}
                        style={{
                            display: `${
                                this.state.isFocused ? 'block' : 'none'
                            }`
                        }}
                        ref={el => (this.$dropOuterFixed = el)}
                    >
                        <div
                            className={`view-wrapper${
                                this.props.extra ? ' extra' : ''
                            }`}
                            ref={el => {
                                this.$container = el;
                            }}
                        >
                            {exercisesListTop}
                            <MDList
                                show={this.state.isFocused}
                                items={items}
                                selectedIndex={this.state.itemPosition}
                                itemsRef={this.itemsRef}
                                container={this.$container}
                                onItemSelect={this.handleSelect}
                            />
                            <div className="MegaDrop-list-bottom">
                                {createNew}
                            </div>
                        </div>
                    </div>
                    <div
                        className={`MegaDrop-menu-outer-filter${
                            this.state.isFocused ? ' active' : ''
                        }`}
                        style={{
                            display: `${
                                this.state.isFocused ? 'block' : 'none'
                            }`
                        }}
                        ref={el => (this.$dropOuterFilterFixed = el)}
                    >
                        <div
                            className={`filter-wrapper${
                                selectedTags.length > 0 ? ' tags-selected' : ''
                            }`}
                            ref={el => {
                                this.$filterContainer = el;
                            }}
                        >
                            {filtersListTop}
                            <MDList
                                show={this.state.isFocused}
                                selectedTags={this.props.selectedTags}
                                items={allTags}
                                container={this.$filterContainer}
                                onItemSelect={this.handleFilterSelect}
                                isFilter={true}
                            />
                            <div className="MegaDrop-list-bottom">
                                {clearFilters}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="MegaDrop-backdrop" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/MegaDrop/MegaDrop.jsx